import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Weather.css";

import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";

export default function Weather(props) {
  const [city, setCity] = useState(props.defaultCity);
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [unit, setUnit] = useState("metric");
  const [currentUnit, setCurrentUnit] = useState("C");
  useEffect(() => {
    setWeatherData(false);
  }, [unit]);
  function handleResponse(response) {
    console.log(response.data);
    setWeatherData({
      ready: true,
      coordinates: response.data.coord,
      date: new Date(response.data.dt * 1000),
      temperature: response.data.main.temp,
      city: response.data.name,
      description: response.data.weather[0].description,
      wind: response.data.wind.speed,
      humidity: response.data.main.humidity,
      precipitation: "3",
      iconUrl: `http://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`,
    });
  }

  function Search() {
    const apikey = "9387dd894fd0810149304594a8204913";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apikey}&units=${unit}`;
    axios.get(apiUrl).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    Search();
  }

  function handleCItyChange(event) {
    setCity(event.target.value);
  }
  function showToFahrenheit(event) {
    event.preventDefault();
    setUnit("imperial");
    setCurrentUnit("°F");
  }

  function showToCelsius(event) {
    event.preventDefault();
    setUnit("metric");
    setCurrentUnit("°C");
  }
  function cm(...args) {
    return args.filter((v) => v).join(" ");
  }

  if (weatherData.ready) {
    return (
      <div className="Weather">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-6">
              <input
                type="search"
                placeholder="Enter a city..."
                className="form-control"
                autoFocus="on"
                onChange={handleCItyChange}
              />
            </div>
            <div className="col-3">
              <input
                type="submit"
                value="Search"
                className="btn btn-primary w-100"
              />
            </div>
            <div className="col-1">
              <div className="btn-group unitGroup">
                <a
                  href="/"
                  className={cm(
                    "currentUnit",
                    currentUnit === "°C" && "active"
                  )}
                  onClick={showToCelsius}
                >
                  °C
                </a>
              </div>
            </div>
            <div className="col-1">
              <div className="btn-group unitGroup">
                <a
                  href="/"
                  className={cm(
                    "currentUnit",
                    currentUnit === "°F" && "active"
                  )}
                  onClick={showToFahrenheit}
                >
                  °F
                </a>
              </div>
            </div>
          </div>
        </form>
        <div className="weatherInfo">
          <WeatherInfo
            data={weatherData}
            coordinates={weatherData.coordinates}
            selectedUnit={unit}
            currentUnit={currentUnit}
          />
        </div>
        <WeatherForecast
          coordinates={weatherData.coordinates}
          selectedUnit={unit}
          currentUnit={currentUnit}
        />
      </div>
    );
  } else {
    Search();
    return "Loading...";
  }
}
